import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/')({
});
